import axios from "axios";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL, FORMAT_COMMON_ID } from "../../utils/EmpUtil";

class DealerDeliveryRangesClient {
  static baseUrl = BASE_URL;

  static async getDealerDeliveryRanges(user, market = null) {
    let url = `${
      this.baseUrl
    }/dealer/deliveryRanges?dealerCommonId=${FORMAT_COMMON_ID(user.commonId)}`;

    if (market !== null) {
      url = url.concat(`&selectedMarket=${market}`);
    }

    return await axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  static async getDealerDeliveryRangesNew(user, market = null) {
    let url = `${
      this.baseUrl
    }/new/dealer/deliveryRanges?dealerCommonId=${FORMAT_COMMON_ID(
      user.commonId
    )}`;

    if (market !== null) {
      url = url.concat(`&selectedMarket=${market}`);
    }

    return await axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  static async saveDealerDeliveryRanges(data, user, commonIds) {
    const url = `${this.baseUrl}/dealer/deliveryRanges?dealerCommonIds=${commonIds}`;
    await axios.post(url, data, getHeaders(user.token));
  }

  static async saveDealerDeliveryRangesNew(data, user, dealers, saveToOld) {
    const url = `${this.baseUrl}/new/dealer/deliveryRanges`;
    data.dealerIds = dealers;
    data.saveToOld = saveToOld;

    await axios.post(url, data, getHeaders(user.token));
  }
}

export default DealerDeliveryRangesClient;
